import { render } from "./HeZuoAnLiApiDataView.vue?vue&type=template&id=19b207c1&scoped=true"
import script from "./HeZuoAnLiApiDataView.vue?vue&type=script&lang=js"
export * from "./HeZuoAnLiApiDataView.vue?vue&type=script&lang=js"

import "./HeZuoAnLiApiDataView.vue?vue&type=style&index=0&id=19b207c1&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b207c1"]])

export default __exports__